/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import { Text, View } from '@az/starc-ui';
import styles from './styles.module.scss';

type PurchasedForProps = {
  vehicle: string;
};

const labelMap = {
  purchasedFor: 'label_reviews_purchasedFor',
};

export const PurchasedFor = ({ vehicle }: PurchasedForProps) => {
  const labels = useLabels(labelMap);

  return (
    <View direction={'row'}>
      <Text variant="small-body">
        <span className={styles.purchasedForText}>{`${labels.purchasedFor} `}</span>
        {vehicle}
      </Text>
    </View>
  );
};
